export default __webpack_public_path__ + "static/media/191.eba79167.jpg";